export default {
  defultnotData: '暫無數據',
  filternotData: '當前篩選條件下沒有數據',
  backtitle: '返回',
  modal: {
    okText: '確定',
    cancelText: '取消',
    okTextSave: '保存',
    cancelTaxtClose: '關閉'
  }
}
